import React from "react"
import { COLORS } from "../../../utilities/Constants"

// Couvertures d'assistance (GE-60) : briques visuelles communes, calquées
// sur la maquette validée docs/couvertures/maquette-couvertures.html.

// « 540.– », « 480.50 » ; null → « montant non précisé » (au choix).
export const chf = (valeur, vide = "—") => {
	if (valeur === null || valeur === undefined || valeur === "") return vide
	const n = Number(valeur)
	if (Number.isNaN(n)) return vide
	return Number.isInteger(n) ? `${n}.–` : n.toFixed(2)
}

export const SOURCE_ICONE = {
	email: "✉",
	telephone: "☎",
	manuel: "✍",
	import: "✉",
}
export const SOURCE_TEXTE = {
	email: "e-mail",
	telephone: "téléphone",
	manuel: "autre",
	import: "import",
}

const BADGES = {
	active: { label: "Active", color: "#166534", bg: "#DCFCE7" },
	utilisee: { label: "Utilisée", color: COLORS.textMuted, bg: COLORS.bg },
	proposee: { label: "À valider", color: "#B45309", bg: "#FEF3C7" },
	annulee: { label: "Annulée", color: COLORS.textMuted, bg: COLORS.bg },
	convertie: { label: "Convertie", color: COLORS.textMuted, bg: COLORS.bg },
}

export const Badge = ({ children, color, bg, border = null, style = null }) => (
	<span
		style={{
			padding: "2px 10px",
			borderRadius: 99,
			fontSize: 11,
			fontWeight: 700,
			display: "inline-flex",
			alignItems: "center",
			gap: 5,
			whiteSpace: "nowrap",
			color,
			backgroundColor: bg,
			...(border ? { border: `1px solid ${border}` } : null),
			...style,
		}}
	>
		{children}
	</span>
)

export const StatutBadge = ({ c }) => {
	if (c.statut === "convertie" && c.convertie_en)
		return (
			<Badge color={COLORS.textMuted} bg={COLORS.bg}>
				Convertie en mission M{c.convertie_en}
			</Badge>
		)
	const b = BADGES[c.statut_affiche] || BADGES.active
	return (
		<Badge color={b.color} bg={b.bg}>
			{b.label}
		</Badge>
	)
}

// « ☎ non confirmée » : saisie bureau active, en attente de l'e-mail (§2).
export const NonConfirmee = () => (
	<Badge
		color="#92400E"
		bg={COLORS.warningLight}
		border="#FDE68A"
		style={{ fontWeight: 600 }}
	>
		☎ non confirmée
	</Badge>
)

// Pastilles du type d'appel (sélecteur, maquette .b-police / .b-prive / .b-assist).
export const APPEL_BADGE = {
	0: { color: "#0F766E", bg: "#CCFBF1", label: "Assistance" },
	1: { color: "#1D4ED8", bg: "#DBEAFE", label: "Police" },
	2: { color: "#6D28D9", bg: "#EDE9FE", label: "Privé" },
}

export const NIVEAU = {
	certaine: { color: "#166534", bg: "#DCFCE7" },
	probable: { color: "#1D4ED8", bg: "#DBEAFE" },
	possible: { color: COLORS.textMuted, bg: COLORS.bg },
}

// Raison d'une correspondance (maquette .reason / .strong / .warn) ; « trouve »
// = ce que la saisie a trouvé (mis en évidence comme une raison forte).
export const Raison = ({ r }) => {
	const fort = r.force === "fort" || r.force === "trouve"
	const warn = r.force === "warn"
	return (
		<span
			style={{
				fontSize: 11.5,
				borderRadius: 6,
				padding: "1px 7px",
				backgroundColor: fort
					? COLORS.successLight
					: warn
						? COLORS.warningLight
						: COLORS.bg,
				border: `1px solid ${
					fort ? "#BBF7D0" : warn ? "#FDE68A" : COLORS.border
				}`,
				color: fort ? "#166534" : warn ? "#92400E" : COLORS.text,
				fontWeight: fort ? 600 : 400,
			}}
		>
			{r.libelle}
		</span>
	)
}

// Lignes d'aperçu d'un plan (serveur) : ton "x" = rouge, "warn" = encadré ambre.
export const Apercu = ({ lignes, vide = null, style = null }) => {
	if (!lignes || !lignes.length)
		return vide ? (
			<div style={{ ...ui.apercu, ...style }}>
				<span style={{ color: COLORS.textMuted }}>{vide}</span>
			</div>
		) : null
	const normales = lignes.filter((l) => l.ton !== "warn")
	const warns = lignes.filter((l) => l.ton === "warn")
	return (
		<>
			{normales.length > 0 && (
				<div style={{ ...ui.apercu, ...style }}>
					{normales.map((l, i) => (
						<div
							key={`ap_${i}`}
							style={
								l.ton === "x" ? { color: COLORS.danger } : null
							}
						>
							{l.texte}
						</div>
					))}
				</div>
			)}
			{warns.map((l, i) => (
				<div key={`apw_${i}`} style={ui.warnbox}>
					{l.texte}
				</div>
			))}
		</>
	)
}

export const ui = {
	btn: (variante = "", petit = false) => ({
		borderRadius: 8,
		padding: petit ? "4px 10px" : "7px 14px",
		fontSize: petit ? 12.5 : 13,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
		whiteSpace: "nowrap",
		border: `1px solid ${
			variante === "primary"
				? COLORS.text
				: variante === "danger"
					? COLORS.dangerBorder
					: COLORS.border
		}`,
		backgroundColor: variante === "primary" ? COLORS.text : COLORS.surface,
		color:
			variante === "primary"
				? "#fff"
				: variante === "danger"
					? COLORS.danger
					: COLORS.text,
	}),
	lien: {
		color: COLORS.accent,
		cursor: "pointer",
		fontWeight: 500,
		fontSize: 12.5,
		background: "none",
		border: 0,
		padding: 0,
		fontFamily: "inherit",
	},
	mono: {
		fontFamily: "ui-monospace, Menlo, monospace",
		fontSize: 12.5,
		fontWeight: 600,
	},
	apercu: {
		marginTop: 14,
		padding: "12px 14px",
		borderRadius: 12,
		backgroundColor: COLORS.bg,
		border: `1px solid ${COLORS.border}`,
		fontSize: 13,
		lineHeight: 1.5,
	},
	warnbox: {
		marginTop: 10,
		display: "flex",
		gap: 8,
		fontSize: 13,
		padding: "9px 12px",
		borderRadius: 10,
		backgroundColor: COLORS.warningLight,
		color: "#92400E",
		border: "1px solid #FDE68A",
	},
	erreur: {
		marginTop: 12,
		padding: "9px 12px",
		borderRadius: 10,
		backgroundColor: COLORS.dangerLight,
		border: `1px solid ${COLORS.dangerBorder}`,
		color: COLORS.danger,
		fontSize: 13,
	},
	// Formulaires des modals (maquette .form / .field).
	form: (colonnes) => ({
		display: "grid",
		gridTemplateColumns:
			colonnes === 1 ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))",
		gap: "12px 16px",
	}),
	fieldLabel: {
		display: "block",
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
		marginBottom: 5,
	},
	input: {
		width: "100%",
		border: `1px solid ${COLORS.border}`,
		borderRadius: 8,
		padding: "8px 10px",
		fontFamily: "inherit",
		fontSize: 13,
		backgroundColor: COLORS.surface,
		color: COLORS.text,
		boxSizing: "border-box",
		outline: "none",
	},
	pill: (actif) => ({
		border: `1px solid ${actif ? COLORS.accent : COLORS.border}`,
		backgroundColor: actif ? COLORS.accentLight : COLORS.surface,
		color: actif ? COLORS.accent : COLORS.textMuted,
		borderRadius: 99,
		padding: "4px 11px",
		fontSize: 12.5,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
	}),
	pills: { display: "flex", flexWrap: "wrap", gap: 6 },
	hint: {
		marginTop: 6,
		fontSize: 12.5,
		padding: "8px 10px",
		borderRadius: 8,
		backgroundColor: COLORS.accentLight,
		color: "#1E40AF",
		border: "1px solid #BFDBFE",
	},
}

// Largeur d'écran (formulaires sur une colonne en dessous de 720 px, comme
// la maquette).
export const useEtroit = (seuil = 720) => {
	const [etroit, setEtroit] = React.useState(
		() => typeof window !== "undefined" && window.innerWidth < seuil,
	)
	React.useEffect(() => {
		const f = () => setEtroit(window.innerWidth < seuil)
		window.addEventListener("resize", f)
		return () => window.removeEventListener("resize", f)
	}, [seuil])
	return etroit
}
